export const PROJECT_DEBIT = 'vivienda/debit/PROJECT_DEBIT'

export function fetchProject(data) {
    return {
        type: PROJECT_DEBIT,
        payload: data
    }
}